export default [
    {
        path: '/flight/classification',
        props: true,
        component: () => import('@/views/Flight/Classification'),
    },
];
